import { ExceptionWeights } from "@/enums/exceptions/exception-weights.ts"
import { BaseException } from "@/exceptions/base-exception.exception.ts"

export class WorkPeriodDoesNotAcceptChangesException extends BaseException {
  exceptionId = "WORK_PERIOD_DOES_NOT_ACCEPT_CHANGES"
  title = "Terugkoppeling niet toegestaan"
  weight = ExceptionWeights.ERROR

  public getMessage(): string {
    return "Deze dienst kan niet meer worden gewijzigd. Neem contact op met de planning."
  }
}

export class PlanningWorkPeriodDoesNotAcceptChangesException extends WorkPeriodDoesNotAcceptChangesException {
  title = "Dienst kan niet worden gewijzigd"

  public getMessage(): string {
    return "Deze dienst kan niet worden gewijzigd omdat er al inkoop- of verkooptijden voor deze datum zijn ingevuld. Maak deze tijden eerst leeg om de dienst aan te passen."
  }
}
